import BaseAuth from 'nast-auth'

/**
 *
 */
export default class NastAuth extends BaseAuth {

}
